import { Mark, mergeAttributes } from "@tiptap/core";

/**
 * Inline mark applied to the anchor block when the agent has staged a
 * structural REPLACEMENT for it (the proposed content lives in an adjacent
 * `agent_suggestion_block` node). The mark renders the anchor text with a red
 * strike-through so the user sees "this is being replaced by ↓ that" before
 * accepting.
 *
 * The mark carries `editId` matching `AgentSuggestionBlock.attrs.anchorEditId`
 * so accept/reject commands can correlate the two. The mark is not its own
 * accept/reject target — only the block's buttons are. Removing this mark is
 * handled by the block's reject command (and the block's accept command
 * deletes the entire anchor block, mark and all).
 */
export const AgentPendingReplace = Mark.create({
    name: "agent_pending_replace",

    addAttributes() {
        return {
            editId: { default: "" }
        };
    },

    parseHTML() {
        return [{ tag: "span[data-agent-pending-replace]" }];
    },

    renderHTML({ HTMLAttributes, mark }) {
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                "data-agent-pending-replace": "true",
                "data-edit-id": String(mark.attrs.editId ?? ""),
                class: "sx-pending-replace"
            }),
            0
        ];
    }
});
